import {
  ShieldAlert, Briefcase, CalendarClock, UserPlus, MessageSquare, Banknote, Bell,
} from "lucide-react";

/**
 * Category → icon, mirroring mobile's CATEGORY_ICON_MAP in
 * Screens/Notifications/notification-cell (lucide-react equivalents of the
 * material-community icon names used there).
 */
const CATEGORY_ICON_MAP = {
  AccountAndSecurity: ShieldAlert,
  BusinessAssistant: Briefcase,
  EventManagement: CalendarClock,
  Invitations: UserPlus,
  ChatActivity: MessageSquare,
  Monetization: Banknote,
};

export const getNotificationIcon = (categoryName) => CATEGORY_ICON_MAP[categoryName] || Bell;

/** Dependency-free relative-time formatter (mirrors mobile's moment().fromNow()). */
export const formatRelativeTime = (dateString, t) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const seconds = Math.max(0, Math.floor((Date.now() - date.getTime()) / 1000));

  if (seconds < 60) return t("time.justNow");
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return t("time.minutesAgo", { count: minutes });
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return t("time.hoursAgo", { count: hours });
  const days = Math.floor(hours / 24);
  if (days < 7) return t("time.daysAgo", { count: days });
  return date.toLocaleDateString();
};

/**
 * Best-effort click-through routing, scoped to the routes that actually
 * exist in this promoter-only panel (mobile's switch statement covers many
 * consumer/joiner flows this panel doesn't have). OriginatorType values are
 * the same ones the backend's NotificationService.NotificationCategoryMapper
 * uses to assign a CategoryId. Returns null when there's no sensible
 * destination — callers should just mark the item read in that case.
 */
export const resolveNotificationRoute = (item) => {
  const originatorType = item?.Notification?.OriginatorType;
  const eventId = item?.Notification?.EventId;

  switch (originatorType) {
    case "device_login_approval":
    case "newDeviceLogin":
      return "/linked-devices";

    case "AccountVerified":
    case "hostUserApproved":
    case "hostUserRequest":
    case "hostUserRejected":
      return "/settings";

    case "event_join_request":
    case "event_join_approved":
    case "event_join_rejected":
      return "/access-requests";

    case "event_limit_pending":
    case "event_limit_approved":
    case "event_limit_rejected":
    case "EventDeleted":
      return "/events";

    case "gallery_purchased":
    case "payment_received":
    case "payout_released":
      return "/wallet";

    case "ChatRoomUser":
    case "UserLeftChatroom":
    case "AlbumLive":
      return "/rooms";

    case "BAEventInvite":
    case "BAEventAccept":
    case "gallery_media_updated":
    case "user_joinned_event":
    case "user_joinned_ARoom":
    case "ShareGalleryParticipationReminder":
    case "subpromoter_joined":
    case "assistant_wants_subpromoter":
    case "EventInvite":
    case "EventInviteCancelled":
      return eventId ? `/events/${eventId}` : "/events";

    default:
      return eventId ? `/events/${eventId}` : null;
  }
};
